<template>
    <!--Saved offers content-->
    <div class="myskov-saved-offers">
            <msg-block v-if="!loading && !hotelBlocks.length && !error">
                <p><b v-text="translations.no_offers"></b></p>
                <p><a href="/" v-text="translations.no_offers_ctr"></a></p>
            </msg-block>
            <msg-block type="error" v-if="error">
                <p><b v-text="error"></b></p>
            </msg-block>
            <msg-block v-if="loading">
                <p><b v-text="translations.loading"></b></p>
            </msg-block>
        <div class="hotel-grid">
            <hotel-block v-for="(hotelBlock, hotelKey) in hotelBlocks" :hotel="hotelBlock" :key="hotelBlock.id" :is-favorite-item="true"></hotel-block>
        </div>
    </div>
</template>
<script>
import HotelBlock from './../hotel-block/hotel-block.vue';
import SkovApi from '../../skovapi.js';
import MsgBlock from '../msg-block.vue';
import Moment from 'moment';
import _ from 'underscore';

export default {
    data() {
        return {
            loading: false,
            translations: APP_CONFIG.TRANSLATION.MYSKOV_SAVED_OFFERS,
            error: null
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        removeFavorite(id) {
            this.$store.dispatch('removeFavorite', id);
        },
        loadData() {
            if(this.loading)
                return;

            this.loading = true;
            this.$store.dispatch('getFavorites').then(() => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        }
    },
    computed: {
        hotelBlocks() {
            if(this.loading) {
                return [{loading: true}, {loading: true}, {loading: true}, {loading: true}, {loading: true}, {loading: true}];
            }

            return this.$store.state.favorites.map((offer) => {
                return {
                    id: _.propertyOf(offer)(['hotel','id']) || null,
                    title: _.propertyOf(offer)(['hotel', 'name']) || '',
                    location: _.propertyOf(offer)(['hotel','location', 'name']) || '',
                    rating: _.propertyOf(offer)(['hotel', 'rating']) || { },
                    stars: _.propertyOf(offer)(['hotel', 'category']) || 0,
                    img: _.propertyOf(offer)(['hotel', 'mediaData', 'thumbnail']) || '',
                    description: _.propertyOf(offer)(['hotel','mediaData','previewText','text']) || '',
                    favoriteId: offer.id
                }
            });
        }
    },
    components: {
        HotelBlock,
        MsgBlock
    }
}
</script>

